module.exports = __webpack_public_path__ + "static/media/cheatsheet.913f9282.png";